import {Api} from '../../Api.js'

const RESOURCE = 'google'

export default {
    resource: RESOURCE,
    getVisits(period, provider) {
        return Api().get(this.resource + '/visits?period=' + period + "&provider=" + provider )
    },
    getSources(period, provider) {
        return Api().get(this.resource + '/sources?period=' + period + "&provider=" + provider )
    }
}


// WEBPACK FOOTER //
// ./src/modules/google/GoogleAnalyticsService.js